module.exports = __webpack_public_path__ + "Icon_Vacations Type.20823e2b660ac019a0d7.png";